export const hasNonEmptyObject = (obj) =>
  !!obj && typeof obj === 'object' && Object.keys(obj).length > 0

export const hasNonEmptyArray = (arr) =>
  Array.isArray(arr) && arr.length > 0
